export const SETTINGS_WORKSPACE_HEADER_ID = "settings-workspace-header";
export const settingsWorkspaceHeaderSelector = `#${SETTINGS_WORKSPACE_HEADER_ID}`;
